import { useLocation } from 'react-router-dom';
import { StockSelectionMode, type StockSelectionContext } from './types';
import { StockViewPage } from './view';
import { StockSingleSelectPage } from './single-select';
import { StockMultiSelectPage } from './multi-select';

export default function StockPage() {
  const location = useLocation();
  const selectionContext = getSelectionContext(location.state);

  switch (selectionContext.mode) {
    case StockSelectionMode.SINGLE_STOCK_SELECTION:
      return <StockSingleSelectPage />;
    case StockSelectionMode.MULTIPLE_STOCK_SELECTION:
      return <StockMultiSelectPage />;
    case StockSelectionMode.STOCK_VIEW:
    default:
      return <StockViewPage />;
  }
}

function getSelectionContext(state: unknown): StockSelectionContext {
  const context = state as StockSelectionContext;
  if (context?.mode) {
    return context;
  }

  return {
    mode: StockSelectionMode.STOCK_VIEW,
  };
}
